export enum MovementType {
  TIME_SERIES = 'Time Series',
  WAVE_RELATED = 'Wave Related',
  EQUIVALENT_HARMONIC = 'Equivalent Harmonic',
  EQUIVALENT_WAVE = 'Equivalent Wave',
  WAVE_WINDOW = 'Wave Window',
}
